import { lazy } from 'react';
import { RouteType } from '@/lib/route';

const Scorm = lazy(() => import('.'));

const ScormRoutes: RouteType = {
  path: '/scorm/course/:token/:frameId?',
  component: Scorm,
};

export interface ScormParamType {
  token: string;
  frameId?: string;
}

export default ScormRoutes;
